import { useState } from 'react';
import { axiosApi } from '../../api/setupApi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const useLoginIA = () => {
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const normalizeYears = (value) => {
    const years = Array.isArray(value)
      ? value.map((item) => String(item?.years ?? item?.year ?? item?.value ?? item ?? '').trim())
      : typeof value === 'string'
        ? value.split(',').map((item) => item.trim())
        : [];

    return [...new Set(years.filter(Boolean))];
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!String(code).trim() || !/^[0-9]+$/.test(String(code).trim())) {
      const message = 'IA code must be numeric.';
      setError(message);
      toast.error(message);
      return;
    }

    if (!password) {
      const message = 'Password is required.';
      setError(message);
      toast.error(message);
      return;
    }

    try {
      setLoading(true);
      const response = await axiosApi.post('/api/nisia/login', {
        code: String(code).trim(),
        password,
      });

      const { token, user } = response.data;
      if (!token) {
        throw new Error('Invalid IA login response');
      }

      const availableYears = normalizeYears(user?.availableYears ?? user?.years ?? user?.year);
      const selectedYear = String(user?.selectedYear ?? user?.year ?? user?.years ?? availableYears[0] ?? '').trim();
      const normalizedUser = {
        ...(user || {}),
        year: selectedYear,
        years: selectedYear,
        selectedYear,
        availableYears: availableYears.length > 0 ? availableYears : (selectedYear ? [selectedYear] : []),
      };

      console.log('[useLoginIA] Years parsing:', {
        loginResponse: { availableYears: user?.availableYears, years: user?.years, selectedYear: user?.selectedYear },
        normalized: { availableYears, selectedYear },
      });

      localStorage.setItem('iaToken', token);
      localStorage.setItem('iaRole', 'ia');
      localStorage.setItem('iaCode', String(user?.code || code).trim());
      localStorage.setItem('iaUser', JSON.stringify(normalizedUser));

      toast.success('IA login successful! Redirecting...');

      setTimeout(() => {
        navigate('/DashboardIA', { replace: true });
      }, 1000);
    } catch (err) {
      const message = err.response?.data?.message || 'IA login failed. Please try again.';
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return {
    code,
    setCode,
    password,
    setPassword,
    error,
    setError,
    loading,
    handleLogin,
  };
};

export default useLoginIA;